module.exports = "/_next/static/images/33877d16207bf28c94a0f5883c8f7323-WhatIsNuPlaca.png";